// export const ApiConfig = {
//   host: '192.168.1.92:8000',
//   protocol: 'http',
//   apiKey: 'BQucBzRn0NbRHIb6f3SeFGi5Kg8mXcMV',
//   pathPrefix: '',
// };

export const ApiConfig = {
  host: 'office.perfect-tour.eu',
  protocol: 'https',
  apiKey: 'BQucBzRn0NbRHIb6f3SeFGi5Kg8mXcMV',
  pathPrefix: '',
};

export const StoreApiConfig = {
  host: '',
  protocol: '',
  appKey: '',
  pathPrefix: '',
  uriBasePath: '',
};
